import ImageResizeViewState from '../schema/ImageResizeViewState';

export default function createImageResizeViewState(): ImageResizeViewState {
    return {
        menuTargetPoint: null,
        menuTargetImage: null,
    };
}
